var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationOnlineInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-info",
    "data-name": "Icon metro-info",
    d: "M12.2,8.459a1.034,1.034,0,0,1,1.031-1.031h.687a1.034,1.034,0,0,1,1.031,1.031v.688a1.034,1.034,0,0,1-1.031,1.031h-.687A1.034,1.034,0,0,1,12.2,9.147Zm4.125,9.969h-5.5V17.053H12.2V12.928H10.821V11.553h4.125v5.5h1.375Zm-2.75-16.5a11,11,0,1,0,11,11,11,11,0,0,0-11-11Zm0,19.938a8.938,8.938,0,1,1,8.937-8.938A8.938,8.938,0,0,1,13.571,21.866Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#1266ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOnlineInfo);
export default __webpack_public_path__ + "static/media/Notification-online-info.417762e3bf55776fb2f8b80d92741c79.svg";
export { ForwardRef as ReactComponent };